export function defineColumns(columns) {
    return columns
        .map((column) => {
        if (!column)
            return undefined;
        // panwds/react-table does not work correctly when `width` is undefined.
        // biome-ignore lint/performance/noDelete: must delete
        if (column.width === undefined)
            delete column.width;
        return column;
    })
        .filter(Boolean);
}
//# sourceMappingURL=define_columns.js.map